import { Store } from "vuex";
import type { UserInfo } from "@hb/h5-login/dist/src/model";
import type { AppState } from "../model/store/types";
import logger from "./utils/logger";

/**
 * 方便拿到store
 * 当有些数据很通用，又在store里很深层存储的时候，可以放到这里处理
 *
 */
export class StoreMgr {
  private _store!: Store<AppState>;

  async init(store: Store<any>) {
    this._store = store;
    // this.store.dispatch()
  }

  get store() {
    if (!this._store) {
      logger("storeMgr store is empty");
    }
    return this._store;
  }

  get storeState(): AppState {
    if (!this._store) {
      logger("storeMgr store is empty");
      return {} as AppState;
    }
    return this._store.state;
  }

  get userInfo(): UserInfo {
    return this.storeState.user.userInfo;
  }

  set userInfo(userInfo: UserInfo) {
    if (userInfo && userInfo.token) {
      this._store.commit("user/setUserInfo", userInfo);
    }
  }

  /**
   * 将userInfo重置为初始值
   */
  resetUserInfo() {
    const userInfo = {
      token: "",
      mobile: "",
      userGuid: "",
    };
    this._store.commit("user/setUserInfo", userInfo);
  }
}

/** store数据管理器 */
export const storeMgr = new StoreMgr();
